import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import temp1 from "../images/temp1.png";
import temp2 from "../images/temp2.png";
import temp3 from "../images/temp3.png";
import temp4 from "../images/temp4.png";
import temp5 from "../images/22.jpg";
import temp6 from "../images/c4img.jpg";
import Footer from "../Footer";
import "../App.css";

function ChooseTemplates() {
  document.title = "HR School-Choose Templates";
  return (
    <div>
      <Header />
      <div
        id="certificatediv"
        style={{
          height: "100%",
          width: "100%",
          padding: "5px",
        }}
      >
        <Link
          to="/certificate"
          style={{
            margin: "12px",
            height: "450px",
            width: "45%",
            float: "left",
          }}
          id="certificatelink"
        >
          <img
            id="certificateimg"
            src={temp1}
            alt=""
            style={{
              height: "100%",
              width: "100%",
            }}
          />
        </Link>{" "}
        <Link
          to="/certificate2"
          id="certificatelink"
          style={{
            margin: "12px",
            height: "450px",
            width: "45%",
            float: "left",
          }}
        >
          {" "}
          <img
            id="certificateimg"
            src={temp2}
            alt=""
            style={{
              height: "100%",
              width: "100%",
            }}
          />
        </Link>
        <Link
          to="/certificate3"
          id="certificatelink"
          style={{
            margin: "12px",
            height: "450px",
            width: "45%",
            float: "left",
          }}
        >
          {" "}
          <img
            id="certificateimg"
            src={temp3}
            alt=""
            style={{
              height: "100%",
              width: "100%",
            }}
          />
        </Link>
        <Link
          to="/certificate4"
          id="certificatelink"
          style={{
            margin: "12px",
            height: "450px",
            width: "45%",
          }}
        >
          {" "}
          <img
            id="certificateimg"
            src={temp4}
            alt=""
            style={{
              height: "100%",
              width: "100%",
            }}
          />
        </Link>
        <Link
          to="/certificate5"
          id="certificatelink"
          style={{
            margin: "12px",
            height: "450px",
            width: "45%",
          }}
        >
          {" "}
          <img
            id="certificateimg"
            src={temp5}
            alt=""
            style={{
              height: "100%",
              width: "100%",
            }}
          />
        </Link>
        <Link
          to="/certificate6"
          id="certificatelink"
          style={{
            margin: "12px",
            height: "450px",
            width: "45%",
          }}
        >
          {" "}
          <img
            id="certificateimg"
            src={temp6}
            alt=""
            style={{
              height: "100%",
              width: "100%",
            }}
          />
        </Link>
      </div>

      <Footer />
    </div>
  );
}

export default ChooseTemplates;
